import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  filter: {
    '=': [
      {
        '@.': '!id',
      },
      {
        '@$': 'subawardId',
      },
    ],
  },
  target: 'ent:!subawards:!subaward',
  quantity: 1,
  selection: {
    '{}': {
      type: 'metric',
      content: {
        '{}': {
          name: 'Computed Risk Level',
          event: {
            '{}': {
              time: {
                if: [
                  [
                    {
                      or: [
                        {
                          '=': [
                            {
                              '@': 'subawardSnapshot',
                            },
                            null,
                          ],
                        },
                        {
                          '=': [
                            {
                              '@': 'subrecipient',
                            },
                            null,
                          ],
                        },
                      ],
                    },
                    null,
                  ],
                  {
                    '++': [
                      '(',
                      {
                        if: [
                          [
                            {
                              '>': [
                                {
                                  '@>': [
                                    {
                                      '@': 'subawardSnapshot',
                                    },
                                    'scoredDate',
                                  ],
                                },
                                {
                                  '@>': [
                                    {
                                      '@': 'subrecipient',
                                    },
                                    'scoredDate',
                                  ],
                                },
                              ],
                            },
                            {
                              '@>': [
                                {
                                  '@': 'subawardSnapshot',
                                },
                                'scoredDate',
                              ],
                            },
                          ],
                          {
                            '@>': [
                              {
                                '@': 'subrecipient',
                              },
                              'scoredDate',
                            ],
                          },
                        ],
                      },
                      ')',
                    ],
                  },
                ],
              },
            },
          },
          value: {
            if: [
              [
                {
                  or: [
                    {
                      '=': [
                        {
                          '@': 'subawardSnapshot',
                        },
                        null,
                      ],
                    },
                    {
                      '=': [
                        {
                          '@': 'subrecipient',
                        },
                        null,
                      ],
                    },
                  ],
                },
                {
                  '{}': {
                    emphasis: '- ',
                    aside: '/ -',
                  },
                },
              ],
              {
                '{}': {
                  emphasis: {
                    if: [
                      [
                        {
                          '>=': [
                            {
                              '+': [
                                {
                                  '@>': [
                                    {
                                      '@': 'subawardSnapshot',
                                    },
                                    'scored',
                                  ],
                                },
                                {
                                  '@>': [
                                    {
                                      '@': 'subrecipient',
                                    },
                                    'scored',
                                  ],
                                },
                              ],
                            },
                            45,
                          ],
                        },
                        'High',
                      ],
                      [
                        {
                          '>=': [
                            {
                              '+': [
                                {
                                  '@>': [
                                    {
                                      '@': 'subawardSnapshot',
                                    },
                                    'scored',
                                  ],
                                },
                                {
                                  '@>': [
                                    {
                                      '@': 'subrecipient',
                                    },
                                    'scored',
                                  ],
                                },
                              ],
                            },
                            21,
                          ],
                        },
                        'Medium',
                      ],
                      'Low',
                    ],
                  },
                  aside: {
                    '++': [
                      {
                        '+': [
                          {
                            '@>': [
                              {
                                '@': 'subawardSnapshot',
                              },
                              'scored',
                            ],
                          },
                          {
                            '@>': [
                              {
                                '@': 'subrecipient',
                              },
                              'scored',
                            ],
                          },
                        ],
                      },
                      ' / ',
                      {
                        '+': [
                          {
                            '@>': [
                              {
                                '@': 'subawardSnapshot',
                              },
                              'possible',
                            ],
                          },
                          {
                            '@>': [
                              {
                                '@': 'subrecipient',
                              },
                              'possible',
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  quality: {
                    if: [
                      [
                        {
                          '>=': [
                            {
                              '+': [
                                {
                                  '@>': [
                                    {
                                      '@': 'subawardSnapshot',
                                    },
                                    'scored',
                                  ],
                                },
                                {
                                  '@>': [
                                    {
                                      '@': 'subrecipient',
                                    },
                                    'scored',
                                  ],
                                },
                              ],
                            },
                            45,
                          ],
                        },
                        'bad',
                      ],
                      [
                        {
                          '>=': [
                            {
                              '+': [
                                {
                                  '@>': [
                                    {
                                      '@': 'subawardSnapshot',
                                    },
                                    'scored',
                                  ],
                                },
                                {
                                  '@>': [
                                    {
                                      '@': 'subrecipient',
                                    },
                                    'scored',
                                  ],
                                },
                              ],
                            },
                            21,
                          ],
                        },
                        'neutral',
                      ],
                      'good',
                    ],
                  },
                },
              },
            ],
          },
          scored: {
            '+': [
              {
                '@>': [
                  {
                    '@': 'subawardSnapshot',
                  },
                  'scored',
                ],
              },
              {
                '@>': [
                  {
                    '@': 'subrecipient',
                  },
                  'scored',
                ],
              },
            ],
          },
          possible: {
            '+': [
              {
                '@>': [
                  {
                    '@': 'subawardSnapshot',
                  },
                  'possible',
                ],
              },
              {
                '@>': [
                  {
                    '@': 'subrecipient',
                  },
                  'possible',
                ],
              },
            ],
          },
          awardDate: {
            '@>': [
              {
                '@': 'subawardSnapshot',
              },
              'scoredDate',
            ],
          },
          recipDate: {
            '@>': [
              {
                '@': 'subrecipient',
              },
              'scoredDate',
            ],
          },
          computedDate: {
            if: [
              [
                {
                  '>': [
                    {
                      '@>': [
                        {
                          '@': 'subawardSnapshot',
                        },
                        'scoredDate',
                      ],
                    },
                    {
                      '@>': [
                        {
                          '@': 'subrecipient',
                        },
                        'scoredDate',
                      ],
                    },
                  ],
                },
                {
                  '@>': [
                    {
                      '@': 'subawardSnapshot',
                    },
                    'scoredDate',
                  ],
                },
              ],
              {
                '@>': [
                  {
                    '@': 'subrecipient',
                  },
                  'scoredDate',
                ],
              },
            ],
          },
        },
      },
    },
  },
  subqueries: {
    subrecipient: {
      selection: {
        '@': 'subrecipientSnapshot',
      },
      ref: {
        attr: 'attr:ent#!subawards#!subaward:!subrecip',
      },
      target: 'ent:!subrecips:!subrecip',
      subqueries: {
        subrecipientSnapshot: {
          ref: {
            attr: 'attr:snap#!subrecips#!subrecipient_risk_survey:!subj',
          },
          target: 'snap:!subrecips:!subrecipient_risk_survey',
          quantity: 1,
          selection: {
            '{}': {
              scoredDate: {
                '@.': '!when',
              },
              possible: {
                score: {
                  possible: '*',
                },
              },
              scored: {
                score: '*',
              },
            },
          },
        },
      },
    },
    subawardSnapshot: {
      ref: {
        attr: 'attr:snap#!subawards#!subaward_risk_survey:!subj',
      },
      target: 'snap:!subawards:!subaward_risk_survey',
      quantity: 1,
      selection: {
        '{}': {
          scoredDate: {
            '@.': '!when',
          },
          possible: {
            score: {
              possible: '*',
            },
          },
          scored: {
            score: '*',
          },
        },
      },
    },
  },
}
